import { Observable } from 'rxjs';
import { defer } from 'rxjs';
import { tap } from 'rxjs/operators';

export function tapIfUndefined<T>(initalFn: () => void, secondFn: () => void) {
  return (source: Observable<T>) =>
    defer(() => {
      let first = true;
      return source.pipe(
        tap((payload) => {
          if (!first && payload === undefined) {
            secondFn();
          }
          if (first && payload === undefined) {
            initalFn();
          }
          first = false;
        })
      );
    });
}
